import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/founder/invisibility-mode.webp")